function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#161616;}\n\t.st1{fill:#E17726;stroke:#E17726;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:#E27625;stroke:#E27625;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:#D5BFB2;stroke:#D5BFB2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:#233447;stroke:#233447;stroke-linecap:round;stroke-linejoin:round;}\n\t.st5{fill:#CC6228;stroke:#CC6228;stroke-linecap:round;stroke-linejoin:round;}\n\t.st6{fill:#E27525;stroke:#E27525;stroke-linecap:round;stroke-linejoin:round;}\n\t.st7{fill:#F5841F;stroke:#F5841F;stroke-linecap:round;stroke-linejoin:round;}\n\t.st8{fill:#C0AC9D;stroke:#C0AC9D;stroke-linecap:round;stroke-linejoin:round;}\n\t.st9{fill:#161616;stroke:#161616;stroke-linecap:round;stroke-linejoin:round;}\n\t.st10{fill:#763E1A;stroke:#763E1A;stroke-linecap:round;stroke-linejoin:round;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1276.6,240.7c-6.8-4.5-14.3-7.7-21.4-11.7c-4.6-2.6-9.5-4.9-13.5-8.2c-6.8-5.6-5.4-16.6,1.7-21.4 c10.2-6.8,27.1-3,28.9,10.9c0,0.3,0.3,0.5,0.6,0.5h15.4c0.4,0,0.7-0.3,0.6-0.7c-0.8-9.6-4.5-17.6-11.3-22.7 c-6.5-4.9-13.9-7.5-21.8-7.5c-40.7,0-44.4,43.1-22.5,56.7c2.5,1.6,24,12.4,31.6,17.1c7.6,4.7,10,13.3,6.7,20.1 c-3,6.2-10.8,10.5-18.6,10c-8.5-0.5-15.1-5.1-17.4-12.3c-0.4-1.3-0.6-3.8-0.6-4.9c0-0.3-0.3-0.6-0.6-0.6h-16.7 c-0.3,0-0.6,0.3-0.6,0.6c0,12.1,3,18.8,11.2,24.9c7.7,5.8,16.1,8.2,24.8,8.2c22.8,0,34.6-12.9,37-26.3 C1292.2,260.3,1288.3,248.5,1276.6,240.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M551.5,182.1h-7.4h-8.1c-0.3,0-0.5,0.2-0.6,0.4l-13.7,45.2c-0.2,0.6-1,0.6-1.2,0l-13.7-45.2 c-0.1-0.3-0.3-0.4-0.6-0.4h-8.1h-7.4h-10c-0.3,0-0.6,0.3-0.6,0.6v115.4c0,0.3,0.3,0.6,0.6,0.6h16.7c0.3,0,0.6-0.3,0.6-0.6v-87.7 c0-0.7,1-0.8,1.2-0.2l13.8,45.5l1,3.2c0.1,0.3,0.3,0.4,0.6,0.4h12.8c0.3,0,0.5-0.2,0.6-0.4l1-3.2l13.8-45.5 c0.2-0.7,1.2-0.5,1.2,0.2v87.7c0,0.3,0.3,0.6,0.6,0.6h16.7c0.3,0,0.6-0.3,0.6-0.6V182.7c0-0.3-0.3-0.6-0.6-0.6H551.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1020.9,182.1c-0.3,0-0.5,0.2-0.6,0.4l-13.7,45.2c-0.2,0.6-1,0.6-1.2,0l-13.7-45.2c-0.1-0.3-0.3-0.4-0.6-0.4 h-25.4c-0.3,0-0.6,0.3-0.6,0.6v115.4c0,0.3,0.3,0.6,0.6,0.6h16.7c0.3,0,0.6-0.3,0.6-0.6v-87.7c0-0.7,1-0.8,1.2-0.2l13.8,45.5l1,3.2 c0.1,0.3,0.3,0.4,0.6,0.4h12.8c0.3,0,0.5-0.2,0.6-0.4l1-3.2l13.8-45.5c0.2-0.7,1.2-0.5,1.2,0.2v87.7c0,0.3,0.3,0.6,0.6,0.6h16.7 c0.3,0,0.6-0.3,0.6-0.6V182.7c0-0.3-0.3-0.6-0.6-0.6H1020.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M805.5,182.1h-31.1h-16.7h-31.1c-0.3,0-0.6,0.3-0.6,0.6v14.4c0,0.3,0.3,0.6,0.6,0.6h30.5v100.4 c0,0.3,0.3,0.6,0.6,0.6h16.7c0.3,0,0.6-0.3,0.6-0.6V197.7h30.5c0.3,0,0.6-0.3,0.6-0.6v-14.4C806.1,182.4,805.9,182.1,805.5,182.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M904,298.7h15.2c0.4,0,0.7-0.4,0.6-0.8l-31.4-115.8c-0.1-0.3-0.3-0.4-0.6-0.4H882h-10.2H866 c-0.3,0-0.5,0.2-0.6,0.4l-31.4,115.8c-0.1,0.4,0.2,0.8,0.6,0.8h15.2c0.3,0,0.5-0.2,0.6-0.4l9.1-33.7c0.1-0.3,0.3-0.4,0.6-0.4h33.6 c0.3,0,0.5,0.2,0.6,0.4l9.1,33.7C903.5,298.5,903.8,298.7,904,298.7z M864.1,247.7l12.2-45.1c0.2-0.6,1-0.6,1.2,0l12.2,45.1 c0.1,0.4-0.2,0.8-0.6,0.8h-24.4C864.3,248.5,864,248.1,864.1,247.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1163.2,298.7h15.2c0.4,0,0.7-0.4,0.6-0.8l-31.4-115.8c-0.1-0.3-0.3-0.4-0.6-0.4h-5.8H1131h-5.8 c-0.3,0-0.5,0.2-0.6,0.4l-31.4,115.8c-0.1,0.4,0.2,0.8,0.6,0.8h15.2c0.3,0,0.5-0.2,0.6-0.4l9.1-33.7c0.1-0.3,0.3-0.4,0.6-0.4h33.6 c0.3,0,0.5,0.2,0.6,0.4l9.1,33.7C1162.7,298.5,1162.9,298.7,1163.2,298.7z M1123.3,247.7l12.2-45.1c0.2-0.6,1-0.6,1.2,0l12.2,45.1 c0.1,0.4-0.2,0.8-0.6,0.8h-24.4C1123.5,248.5,1123.2,248.1,1123.3,247.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M629.7,281.6v-35.8c0-0.3,0.3-0.6,0.6-0.6h44.5c0.3,0,0.6-0.3,0.6-0.6v-14.4c0-0.3-0.3-0.6-0.6-0.6h-44.5 c-0.3,0-0.6-0.3-0.6-0.6v-30.6c0-0.3,0.3-0.6,0.6-0.6h50.6c0.3,0,0.6-0.3,0.6-0.6v-14.4c0-0.3-0.3-0.6-0.6-0.6h-51.2h-17.3 c-0.3,0-0.6,0.3-0.6,0.6v15v31.9v15.6v37v15.8c0,0.3,0.3,0.6,0.6,0.6h17.3H683c0.3,0,0.6-0.3,0.6-0.6v-15.2c0-0.3-0.3-0.6-0.6-0.6 h-52.8C629.9,282.2,629.7,282,629.7,281.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1429.2,297.7l-57.8-59.7c-0.2-0.2-0.2-0.6,0-0.8l52-54c0.4-0.4,0.1-1-0.4-1h-21.3c-0.2,0-0.3,0.1-0.4,0.2 l-44.1,45.8c-0.4,0.4-1,0.1-1-0.4v-45c0-0.3-0.3-0.6-0.6-0.6h-16.7c-0.3,0-0.6,0.3-0.6,0.6v115.4c0,0.3,0.3,0.6,0.6,0.6h16.7 c0.3,0,0.6-0.3,0.6-0.6v-50.8c0-0.5,0.7-0.8,1-0.4l50,51.6c0.1,0.1,0.3,0.2,0.4,0.2h21.3C1429.3,298.7,1429.6,298,1429.2,297.7z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "366,120 264.9,195 283.7,150.8  "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "132.8,120 233,195.7 215.1,150.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "329.6,293.9 302.7,335.1 360.3,351 376.8,294.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "122.1,294.8 138.5,351 196,335.1 169.2,293.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "192.9,224.3 176.9,248.5 233.9,251.1 232,189.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "305.9,224.3 266.2,188.9 264.9,251.1 321.9,248.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "196,335.1 230.5,318.4 200.8,295.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "268.3,318.4 302.7,335.1 298,295.2  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "302.7,335.1 268.3,318.4 271.1,340.8 270.8,350.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "196,335.1 228,350.3 227.8,340.8 230.5,318.4  "
})), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "228.6,280.4 200,272 220.2,262.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "270.2,280.4 278.6,262.7 298.9,272  "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st5",
  points: "196,335.1 201,293.9 169.2,294.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st5",
  points: "297.8,293.9 302.7,335.1 329.6,294.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st5",
  points: "321.9,248.5 264.9,251.1 270.2,280.4 278.6,262.7 298.9,272  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st5",
  points: "200,272 220.2,262.7 228.6,280.4 233.9,251.1 176.9,248.5  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "176.9,248.5 200.8,295.2 200,272  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "298.9,272 298,295.2 321.9,248.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "233.9,251.1 228.6,280.4 235.3,315 236.8,269.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "264.9,251.1 262.1,269.3 263.5,315 270.2,280.4  "
})), /*#__PURE__*/React.createElement("polygon", {
  className: "st7",
  points: "270.2,280.4 263.5,315 268.3,318.4 298,295.2 298.9,272  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st7",
  points: "200,272 200.8,295.2 230.5,318.4 235.3,315 228.6,280.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st8",
  points: "270.8,350.3 271.1,340.8 268.5,338.6 230.3,338.6 227.8,340.8 228,350.3 196,335.1 207.2,344.3 229.9,360 268.8,360 291.6,344.3 302.7,335.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "268.3,318.4 263.5,315 235.3,315 230.5,318.4 227.8,340.8 230.3,338.6 268.5,338.6 271.1,340.8  "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st10",
  points: "370.3,199.9 378.8,158.5 366,120 268.3,192.5 305.9,224.3 359,239.8 370.7,226.1 365.6,222.4 373.7,215 367.5,210.2 375.6,204  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st10",
  points: "120,158.5 128.6,199.9 123.1,204 131.3,210.2 125.1,215 133.2,222.4 128.1,226.1 139.8,239.8 192.9,224.3 230.5,192.5 132.8,120  "
})), /*#__PURE__*/React.createElement("polygon", {
  className: "st7",
  points: "359,239.8 305.9,224.3 321.9,248.5 298,295.2 329.6,294.8 376.8,294.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st7",
  points: "192.9,224.3 139.8,239.8 122.1,294.8 169.2,294.8 200.8,295.2 176.9,248.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st7",
  points: "264.9,251.1 268.3,192.5 283.7,150.8 215.1,150.8 230.5,192.5 233.9,251.1 235.2,269.5 235.3,315 263.5,315 263.6,269.5  "
}));

function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 1549.4 480",
    style: {
      enableBackground: "new 0 0 1549.4 480"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.5519ee25.svg";
export { ForwardRef as ReactComponent };